import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { HeaderBanner } from '../models/header-banner';
import { HeaderBannerFormValues } from '../models/header-banner-form-values';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';
import { headerBannerDetailRequestSelector } from './header-banner-detail-selectors';

export const HEADER_BANNER_DETAIL_FETCH = 'HEADER_BANNER_DETAIL_FETCH';
export const HEADER_BANNER_DETAIL_RESET = 'HEADER_BANNER_DETAIL_RESET';
export const HEADER_BANNER_DETAIL_CREATE = 'HEADER_BANNER_DETAIL_CREATE';
export const HEADER_BANNER_DETAIL_UPDATE = 'HEADER_BANNER_DETAIL_UPDATE';
export const HEADER_BANNER_DETAIL_RECEIVE = 'HEADER_BANNER_DETAIL_RECEIVE';
export const HEADER_BANNER_DETAIL_ERROR = 'HEADER_BANNER_DETAIL_ERROR';

const receiveHeaderBannerDetail = (headerBanner: HeaderBanner) => {
    return {
        type: HEADER_BANNER_DETAIL_RECEIVE,
        headerBanner,
    };
};

export const resetHeaderBannerDetail = () => {
    return {
        type: HEADER_BANNER_DETAIL_RESET,
    };
};

export const fetchHeaderBannerDetail = (id: number) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: HEADER_BANNER_DETAIL_FETCH });

        const response = await api.contentManagement.HeaderBanner.HeaderBannerDetail.getHeaderBannerDetail(id);

        if (response.success) {
            dispatch(receiveHeaderBannerDetail(response.result));
        } else {
            dispatch({ type: HEADER_BANNER_DETAIL_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveHeaderBannerDetail = (values: HeaderBannerFormValues) => {
    return async (dispatch: ReduxDispatch, getState: () => AppState, { api }: { api: Api }) => {
        const headerBanner = headerBannerDetailRequestSelector(values)(getState());

        let response: ApiResult<HeaderBanner> | null = null;
        if (headerBanner.id) {
            dispatch({ type: HEADER_BANNER_DETAIL_UPDATE });
            response = await api.contentManagement.HeaderBanner.HeaderBannerDetail.updateHeaderBannerDetail(
                headerBanner
            );
        } else {
            dispatch({ type: HEADER_BANNER_DETAIL_CREATE });
            response = await api.contentManagement.HeaderBanner.HeaderBannerDetail.createHeaderBannerDetail(
                headerBanner
            );
        }

        if (response.success) {
            dispatch(receiveHeaderBannerDetail(response.result));
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.headerBannerSaved')));
        } else {
            dispatch({ type: HEADER_BANNER_DETAIL_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
